<div class="content-wrapper">
  <div class="battery-header">
    <h5 class="battery-section-title">
      <mat-icon>monitor_heart</mat-icon>
      <span class="title-label">Nivel de Batería y Cobertura</span>
    </h5>
  </div>

  <hr />

  <ion-grid>
    <ion-row class="graph-content">
      <!-- Gráfico de batería -->
      <ion-col size="12" size-md="6">
        <div class="graph-card">
          <h4 class="chart-title">
            <mat-icon class="ml-1">battery_saver</mat-icon> Nivel de Batería
          </h4>
          <canvas baseChart
                  [data]="batteryChartData"
                  [options]="batteryOptions"
                  [type]="chartType">
          </canvas>
        </div>
      </ion-col>

      <!-- Gráfico de cobertura -->
      <ion-col size="12" size-md="6">
        <div class="graph-card">
          <h4 class="chart-title">
            <mat-icon>signal_cellular_alt</mat-icon> Cobertura
          </h4>
          <canvas baseChart
                  [data]="coverageChartData"
                  [options]="coverageOptions"
                  [type]="chartType">
          </canvas>
        </div>
      </ion-col>

      <!-- Gráfico de errores -->
      <!--
      <ion-col size="12" size-md="12">
        <div class="graph-card graph-card--small">
          <h4 class="chart-title">
            <mat-icon>error</mat-icon> Errores stack
          </h4>
          <canvas baseChart
                  [data]="errorChartData"
                  [options]="errorOptions"
                  [type]="chartType">
          </canvas>
        </div>
      </ion-col>
      -->
    </ion-row>
  </ion-grid>
</div>
